import { FC, useMemo } from 'react';
import Text from '@deprecated-ui/common/Text';
import { formatNumber } from 'utils/number';
import { SPLIT_ORDER_LOT } from 'constants/trading';
import { Container, ListWrapper, TotalLotWrapper } from './styled';

interface SplitLotRowProps {
  lot?: number;
  disabled?: boolean;
}

interface SplitOrderConfig {
  start: number;
  end: number;
  lot: number;
}

const SplitLotRow: FC<SplitLotRowProps> = ({ lot = 0, disabled }) => {
  const splittedLot = useMemo<SplitOrderConfig[]>(() => {
    if (lot <= SPLIT_ORDER_LOT) return [];

    const splitLength = Math.floor(lot / SPLIT_ORDER_LOT);
    const leftOver = lot - SPLIT_ORDER_LOT * splitLength;
    const leftOverArray: SplitOrderConfig[] =
      leftOver > 0
        ? [{ start: splitLength + 1, end: null, lot: leftOver }]
        : [];

    return [
      {
        start: 1,
        end: splitLength > 1 ? splitLength : null,
        lot: SPLIT_ORDER_LOT,
      },
      ...leftOverArray,
    ];
  }, [lot]);

  const isSplitOrder = useMemo(
    () => splittedLot.length > 0 && !disabled,
    [splittedLot],
  );

  return (
    <Container data-cy="split-order-container" isSplitOrder={isSplitOrder}>
      <TotalLotWrapper>
        <Text data-cy="lot-label">Lot</Text>
        <Text data-cy="lot-value">{formatNumber(lot)}</Text>
      </TotalLotWrapper>

      {isSplitOrder ? (
        <ListWrapper>
          {splittedLot.map(({ start, end, lot: lotItemValue }, i) => (
            // eslint-disable-next-line react/no-array-index-key -- no unique id key
            <div key={`split-lot-row-${i}`}>
              <Text data-cy={`list-lot-label-${i}`}>
                Order {start}
                {end ? ` - ${end}` : null}
              </Text>
              <Text data-cy={`list-lot-value-${i}`}>
                {end ? '@' : ''}
                {formatNumber(lotItemValue)}
              </Text>
            </div>
          ))}
        </ListWrapper>
      ) : null}
    </Container>
  );
};

export default SplitLotRow;
